import * as React from 'react';
import { visualize, snap } from 'storybook-snapper';
import { PimpleWiringExample } from './PimpleWiringExample';

visualize('Pimple', () => {
  snap(
    'sizes: large and small',
    <div style={{ backgroundColor: '#F0F4F7', display: 'inline-block' }}>
      <PimpleWiringExample />
    </div>,
  );
});
